module.exports = class Data {

    static obterPorData(data) {
        return obterTodosOsFormatos(data);
    }
    
    static obterPorDataAgora() {
        return obterTodosOsFormatos(new Date());
    }
    
    static obterPorDataStr (dataStr) {
        if (!dataStr) {
            return '';
        }
        const data = new Date(dataStr);
        return obterTodosOsFormatos(data);
    }

    static obterPorDiaMesEAnoStr (dataStr) {
        if (!dataStr) {
            return '';
        }

        let partes = dataStr.split(" ")
        partes = partes[0].split("-")
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    static somarDias = (data,dias) => {
        let novaData = data;
        novaData.setDate(novaData.getDate() + dias + 1);
        return novaData;
    }
    
    static subtrairDias = (data,dias) => {
        return this.somarDias(data,-dias)
    }

    static obterDataFormatada(dataStr) {
        let partes = dataStr.split('.')
        partes = partes[0].split(' ')
        const partesData = partes[0].split('-')
        const dia = partesData[2]
        const mes = partesData[1]
        const ano = partesData[0]
        const partesHora = partes[1].split(':')
        const hora = partesHora[0]
        const minuto = partesHora[1]
        const segundo = partesHora[2]
        const formatadaDataCompleta = `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`
        return formatadaDataCompleta
    }
}

const data_adequa = valor => {
    let _valor = `${valor}`;
    if (_valor.length === 1) {
        _valor = `0${_valor}`;
    }
    return _valor;
}

const obterTodosOsFormatos = data => {

    const res = {
        dia:data_adequa(data.getDate()),
        mes:data_adequa(data.getMonth()+1),
        ano:`${data.getFullYear()}`,
        hora:data_adequa(data.getHours()),
        minuto:data_adequa(data.getMinutes()),
        segundo:data_adequa(data.getSeconds()),
        milisegundos:`${data.getMilliseconds()}`,
        milisegundosDesde1970: data.getTime(),
        formatada:null,
        formatadaSQL:null
    }

    res.formatada =`${res.dia}/${res.mes}/${res.ano} ${res.hora}:${res.minuto}:${res.segundo}.${res.milisegundos}`;
    res.formatadaSQL = `${res.ano}-${res.mes}-${res.dia} ${res.hora}:${res.minuto}:${res.segundo}.${res.milisegundos}`;
    res.formatadaSoData = `${res.dia}/${res.mes}/${res.ano}`;
    res.formatadaSoDataEHora = `${res.dia}/${res.mes}/${res.ano} às ${res.hora}h${res.minuto}min`;
    res.formatadaDataAsHora = `${res.dia}/${res.mes}/${res.ano} às ${res.hora}h${res.minuto}min${res.segundo}s`;
    res.formatadaDataCompleta = `${res.dia}/${res.mes}/${res.ano} ${res.hora}:${res.minuto}:${res.segundo}`;
    res.protocolo = `${res.ano.substr(2)}${res.mes}${res.dia}${res.hora}${res.minuto}${res.segundo}${res.milisegundos}`;
    res.chave = `${res.ano}_${res.mes}_${res.dia}_${res.hora}_${res.minuto}_${res.segundo}_${res.milisegundos}`;
    return res;
}


